module.exports = " <vhead></vhead> <vheadnav></vheadnav> <div id=app> <router></router> </div> <vfooter></vfooter> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/Case.vue
// module id = 268
// module chunks = 6